<section>
  <div class="order-transfer-inner" *ngIf="!isAccountSelect">
    <div class="order-trans-top">
      <div class="order-trans-form">
        <h2>Order Transfer Internal:</h2>
        <div>
          <a class="close-btn-internal" (click)="onInternalClose()">
            Close <i class="fas fa-times"></i>
          </a>
        </div>
        <div class="row" *ngIf="isSubscriptionAccess">
          <div class="col-md-12">
            <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
              <mat-label>Non-Subscriber Email:</mat-label>
              <input matInput type="email" name="accountEmail"
                     placeholder="(Separate multiple email addresses by a semi-colon)"
                     [(ngModel)]="accountEmail"
                     [pattern]="emailPattern"
                     (keyup)="validateEmail()"
                     email="true">
              <mat-error *ngIf="isNotValid">
                This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="order-box-outer">
        <div class="row">
          <div class="col-md-12 text-center order-box-sec">
            <div class="order-box card text-center">
              <div class="card-body">
                <h5 class="card-title">Order</h5>
                <p class="card-text">{{fromDealerOrderId}}</p>
              </div>
            </div>
            <div class="order-box card text-center">
              <div class="card-body">
                <h5 class="card-title">Order</h5>
                <p class="card-text">{{toDealer == null ? '' : (toDealer.orderId ? toDealer.orderId :'New Order')}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row order-box-bottom">
          <div class="col-md-6">
            <div class="orderText fromOrder">
              <span>
                from:
              </span>
              <i class="fas fa-caret-up"></i>
            </div>
          </div>
          <div class="col-md-6">
            <div class="orderText toOrder">
              <span>
                to:
              </span>
              <i class="fas fa-caret-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="transferSec">

      <div class="row">
        <div class="col-md-12">
          <div class="outsideTableContainer margBottom">
            <table class="matTables productTable mat-table">
              <thead>
              <th class="borderR" colspan="4" valign="top">

                <div class="leftColTransfer">
                  <div class="growerInfo">
                    <span class="transferToAccount">
                      FROM:  <h4>
                        {{fromDealer?.accountName}}, {{fromDealer?.city}} - {{fromDealer?.state}}
                      </h4>
                      <p class="accountName mediumFont">
                        {{fromDealer?.address1}}
                      </p>
                      <p class="address ">
                        {{fromDealer?.city}} {{fromDealer?.state}} {{fromDealer?.zipCode}}
                      </p>
                      <p class="address">Account# : {{fromDealer?.accountNumber}}</p>
                    </span>

                  </div>
                </div>
              </th>
              <th colspan="4">
                <div class="rgtColTransfer padding-r0 padding-l0">
                  <div class="growerInfoTo">
                    <div class="row padding-r20">
                      <div class="col-12 borderLine">
                        <div class="row">
                          <div class="col-md-1 margin-r15 transferToAccount">
                            TO:*
                          </div>
                          <div class="col-md-10 margin-t20 margin-l-15">

                            <p><span class="margin-r5" *ngIf="toDealer?.accountName">{{toDealer?.accountName}}</span> <span><a id="aToSelectAccount" class="selectLink transferToSelectLink" [ngClass]="toDealer?.accountName ? 'margin-l30' : 'margin-l0'" (click)="selectAccount()">Click to Select Account</a></span></p>
                          </div>
                        </div>
                      </div>

                      <div class="lineHeight col-md-12">
                        <p class="accountName mediumFont" *ngIf="toDealer?.accountName">{{toDealer?.address1}}</p>
                        <p class="address" *ngIf="toDealer?.accountName">{{toDealer?.city}}, {{toDealer?.state}} - {{toDealer?.zipCode}}</p>
                        <p class="address" *ngIf="toDealer?.accountName">Account #: {{toDealer?.accountNumber}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              </thead>
              <thead>
                <tr class="mat-header-row">
                  <th class="mat-header-cell origProductName">Product</th>
                  <!--<th class="mat-header-cell text-center originalUnit">EA Modifiable Units</th>-->
                  <th class="mat-header-cell text-center modifiedUnit ">Remaining</th>
                  <!--<th class="mat-header-cell text-center eaCheckboxUnit borderR">
                    Reduce EA Modifiable Units <br />
                    <mat-checkbox class="custom-checkbox"
                                  #selectAllReduceEAUnits
                                  [checked]="ngModel"
                                  [(ngModel)]="isAllChecked"
                                  (change)="checkUnchekAllEAUnits(selectAllReduceEAUnits._checked)"
                                  title="Reduce EA Modifiable Units"
                                  [disabled]="!hasEligibleEAUnits">
                    </mat-checkbox>
                  </th>-->
                  <th class="mat-header-cell replacedProductName">Product</th>
                  <th class="mat-header-cell text-center originalUnit">Transferable Units</th>
                  <th class="mat-header-cell text-center editUnit">Units</th>

                </tr>
              </thead>
              <tbody id="tDataList" *ngFor="let o2Order of orderFromToList">
                <tr class="mat-row">

                  <td class="order-info mat-cell origProdNameContent" [ngClass]="!o2Order.isValidForRibTransfer ? 'pt-0':''">
                    <div class="unavailable-block-Sec" *ngIf="!o2Order.isValidForRibTransfer">
                      <div id="main_{{o2Order.rowId}}" class="unavailable-block-outer">
                        <div class="unavailable-block" [ngClass]="o2Order.seedNonReturnable ? 'adjustTopHeight':''">
                          <i class="icon-ico-Banned_Circle"></i>
                        </div>
                        <div class="unavail-content" id="sub_{{o2Order.rowId}}">
                          <h4>Item restricted to transfer to this dealer.</h4>
                        </div>
                      </div>
                    </div>
                    <div class="d-inline-block">
                      <p matTooltip="{{o2Order.Brand}} - {{o2Order.MarketingBrand}}" [matTooltipPosition]="'above'">{{o2Order.Brand}} - {{o2Order.MarketingBrand}}</p>
                      <p class="grower-name" matTooltip="{{o2Order.ItemDescription}}" [matTooltipPosition]="'above'">{{o2Order.ItemDescription}}</p>
                      <p *ngIf="o2Order.seedNonReturnable" class="grower-name nonReturnable">*NON-RETURNABLE</p>
                    </div>
                  </td>
                  <!--<td class="text-center mat-cell">
                    {{o2Order.EAModifiableUnits | number}}
                  </td>-->
                  <td class="text-center mat-cell borderR ">
                    {{o2Order.RemainingQuantity}}
                  </td>
                  <!--<td class="text-center mat-cell borderR">
                    <mat-checkbox #SingleCheck
                                  class="custom-checkbox"
                                  title="Reduce EA Modifiable Units"
                                  (change)="validateReduceEAUnitsChecks(o2Order, SingleCheck._checked)"
                                  [checked]="ngModel"
                                  [(ngModel)]="o2Order.IsSelected"
                                  [disabled]="!(o2Order.EAModifiableUnits > 0 && o2Order.IsItemInInclusion)">

                    </mat-checkbox>
                  </td>-->
                  <td class="order-info mat-cell">
                    <p>{{o2Order.Brand}} - {{o2Order.MarketingBrand}}</p>
                    <p class="grower-name">{{o2Order.ItemDescription}}</p>
                  </td>
                  <td class="text-center mat-cell">
                    {{o2Order.TransferableUnits}}
                  </td>
                  <td class="text-center mat-cell unitData">
                    <div *ngIf="o2Order.isValidForRibTransfer">
                      <button (click)="geuValueChange('decrease',o2Order);o2Order.isSelected=true" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + o2Order.ItemNumber"> - </button>
                      <input type="text" [attr.disabled]="!toDealer ? 'disabled' : null" id="txtUnits" class="geu-txt" [(ngModel)]="o2Order.ToPrimaryQty" (focusout)="validateSelectedCount(o2Order, $event.target.value)" maxlength="5" appNumbersOnly [attr.data-testid]="'qty-' + o2Order.ItemNumber" />
                      <button (click)="geuValueChange('increase',o2Order); o2Order.isSelected=true" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + o2Order.ItemNumber"> + </button>
                    </div>
                  </td>

                </tr>
                <tr *ngIf="o2Order && o2Order.LineErrors.errors.length > 0" id="error_{{o2Order.LineErrors.rowId}}">
                  <td colspan="7">
                    <div class="inline-error">
                      <div class="row">
                        <div class="col-md-9">
                          <ol class="error-list">
                            <li *ngFor="let err of o2Order.LineErrors.errors" class="justify-content-center align-self-center">
                              {{err.error }}
                            </li>
                          </ol>
                        </div>
                        <div class="col-md-3 revertToPrev my-auto px-5" (click)="revertToPreviousError(o2Order, true)">
                          <span>
                            Revert to Previous.
                            <i class="icon-ico-Reply"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row common-error-block mx-0" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index].errors.length > 0">
      <div class="col-md-2 padding-r0 errCountOuter">
        <!--<span class="close-icon">
          <i class="icon-ico-Error"></i>
        </span>-->
        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-md-6 padding-l0 my-auto">
        <ul class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors">
            <p> {{err.error}}</p>
          </li>
        </ul>
      </div>
      <div class="col-md-4 button-sec text-right my-auto">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()">Next Error</button>
      </div>

    </div>

    <div *ngIf="!showErrorBlock" class="tableTotalsSec">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <button mat-raised-button class="btns" color="primary" [disabled]="!isTransfer || modifiedUnitCount<=0 || isNotValid==true" (click)="confirmToTransfer()">Preview Change</button>
          <a style="cursor:pointer" (click)="onCancel()">Cancel </a>
        </div>
        <div class="count">
          Transferred Units:
          <span>
            {{modifiedUnitCount}}/{{originalUnitCount}}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isAccountSelect">
    <app-internal-transfer-select-account [(isAccountClose)]="isAccountSelect" (AccountSelected)="setToAccountData($event)" [(fromDealerIS)]="fromDealer.accountNumber" [(itemRibStatus)]="itemRibStatus"></app-internal-transfer-select-account>
  </div>
</section>
